module.exports = __webpack_public_path__ + "static/media/whatsapp.934130fc.svg";